/**
 * @flow
 * @relayHash 1df483da3f750e9337532caeab4f8834
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type projectDelete_MutationVariables = {|
  input: {
    id: string,
    clientMutationId?: ?string,
  },
|};
export type projectDelete_MutationResponse = {|
  +deleteProject: ?{|
    +deleted_id: ?string,
    +deleted_count: ?number,
  |},
|};
*/


/*
mutation projectDelete_Mutation(
  $input: DeleteProjectInput!
) {
  deleteProject(input: $input) {
    deleted_id
    deleted_count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteProjectInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteProject",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DeleteProjectInput!"
      }
    ],
    "concreteType": "DeleteProjectPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deleted_id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deleted_count",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "projectDelete_Mutation",
  "id": null,
  "text": "mutation projectDelete_Mutation(\n  $input: DeleteProjectInput!\n) {\n  deleteProject(input: $input) {\n    deleted_id\n    deleted_count\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "projectDelete_Mutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "projectDelete_Mutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
(node/*: any*/).hash = 'e883c2109eeae8e4aac944ed16db59e4';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/projectDelete_Mutation.graphql.js